import { useCallback, useEffect, useRef } from 'react'
import { values } from 'ramda'

import FiltersDropDownLayout, { Column } from 'app/common/layouts/FiltersDropDownLayout'
import { FilterItem, useFilterData } from 'app/common/ui-components/filter'
import filterBuilding from 'app/components/common/reports/filters/building'
import { VisuallyHiding } from 'app/components/common/reports/VisuallyHiding'

import periodFilter from './period'
import styles from './FilterWindow.scss'


type Props = {
  onFilter: (v: ((v: boolean) => boolean) | boolean) => void,
  filterActive: boolean,
  loading: boolean,
  foodModeEnable: boolean,
}

const FilterWindow = ({ onFilter, filterActive, loading, foodModeEnable }: Props) => {
  const handleCloseFilterWindow = useCallback(() => {
    onFilter(false)
  }, [onFilter])

  const [, state,, { filtersLoad, resetAll, applyFilters }] = useFilterData()
  const buildingItems = values(state[filterBuilding].items)
  const hasLoadedRef = useRef(false)

  useEffect(() => {
    if (!filterActive) return
    if (!hasLoadedRef.current) {
      hasLoadedRef.current = true
      filtersLoad()
    }
  }, [filterActive, filtersLoad])


  if (!filterActive) {
    return null
  }

  return (
    <FiltersDropDownLayout
      onClose={handleCloseFilterWindow}
      arrowClassName={styles.filterArrow}
      loading={loading}
      onApplyFilter={applyFilters}
      onResetAll={resetAll}
    >
      <Column>
        <FilterItem filterId="year" />
        <FilterItem filterId={periodFilter} />
      </Column>
      <Column>
        {foodModeEnable
          && <FilterItem filterId="foodMode" />}
        <FilterItem filterId="class" />
        <FilterItem filterId="status" />
        <VisuallyHiding hiding={buildingItems.length <= 1}>
          <FilterItem filterId={filterBuilding} />
        </VisuallyHiding>
      </Column>
    </FiltersDropDownLayout>
  )
}

export default FilterWindow
